import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

export default function UseParticles() {
  const init = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      init={init}
      options={{
        fullScreen: false,
        particles: {
          number: { value: 50 },
          color: { value: "#95afcb" },
          move: { enable: true, speed: 2 },
          size: { value: { min: 1, max: 3 } },
        },
      }}
      style={{
        position: "absolute",
        inset: 0,
      }}
    />
  );
}
